import * as Yup from 'yup';
import TextField from '@mui/material/TextField';
import { SxProps } from 'src/theme/types';
import { SolutionOmniverseAppField } from '../../types';

const inputStyle: SxProps = { width: ({ spacing }) => spacing(40) };

export const getSolutionOmniverseAppFormFields = () => [
  {
    name: SolutionOmniverseAppField.Title,
    label: 'Title',
    placeholder: 'Enter title',
    Component: TextField,
    validation: Yup.string().required('Title is required'),
    required: true,
    sx: inputStyle,
  },
  {
    name: SolutionOmniverseAppField.Description,
    label: 'Description',
    placeholder: 'Enter description',
    Component: TextField,
    sx: inputStyle,
  },
  {
    name: SolutionOmniverseAppField.Version,
    label: 'Version',
    placeholder: 'Enter version (e.g. 1.0.0)',
    Component: TextField,
    validation: Yup.string().required('Version is required'),
    required: true,
    sx: inputStyle,
  },
  {
    name: SolutionOmniverseAppField.Category,
    label: 'Category',
    placeholder: 'Enter category',
    Component: TextField,
    validation: Yup.string().required('Category is required'),
    required: true,
    sx: inputStyle,
  },
  {
    name: SolutionOmniverseAppField.ProductArea,
    label: 'Product Area',
    placeholder: 'Enter product area',
    Component: TextField,
    validation: Yup.string().required('Product area is required'),
    required: true,
    sx: inputStyle,
  },
  {
    name: SolutionOmniverseAppField.FunctionId,
    label: 'Function ID',
    placeholder: 'Enter function ID',
    Component: TextField,
    validation: Yup.string().required('Function ID is required'),
    required: true,
    sx: inputStyle,
  },
  {
    name: SolutionOmniverseAppField.FunctionVersionId,
    label: 'Function Version ID',
    placeholder: 'Enter function version ID',
    Component: TextField,
    validation: Yup.string().required('Function Version ID is required'),
    required: true,
    sx: inputStyle,
  },
  {
    name: SolutionOmniverseAppField.Image,
    label: 'Image URL',
    placeholder: 'Enter image URL',
    Component: TextField,
    validation: Yup.string().required('Image URL is required'),
    required: true,
    sx: inputStyle,
  },
];
